export default __webpack_public_path__ + "static/media/logo-blue.b34f1c38.svg";